import { DetailsBackground } from '../details-background/details-background';
import { DetailsMetadata } from '../details-metadata/details-metadata';
import { DetailsHeader } from '../details-view/details-header';
import css from './details-skeleton.module.scss';

export function DetailsSkeleton() {
  return (
    <div className={css.container}>
      <DetailsBackground.Skeleton />
      <DetailsHeader.Skeleton />

      <DetailsMetadata.Skeleton />
    </div>
  );
}
